module.exports = __webpack_public_path__ + "img/section6LegendStar2.f4a145b3.svg";